import script from "./BaseContractPage.vue?vue&type=script&setup=true&lang=ts&generic=T%20extends%20IContractRaw"
export * from "./BaseContractPage.vue?vue&type=script&setup=true&lang=ts&generic=T%20extends%20IContractRaw"

import "./BaseContractPage.vue?vue&type=style&index=0&id=6734985a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6734985a"]])

export default __exports__